/**
 * Constants
 */
const UPDATE_DATA = 'count@UPDATE_DATA';

/**
 * Actions creator
 */
const updateData = data => ({
    type: UPDATE_DATA,
    payload: data,
});

/**
 * Exports
 */
const Actions = {
    updateData,
};

export default Actions;
export {
    UPDATE_DATA,
    updateData,
};



// WEBPACK FOOTER //
// ./actions/CountActions.js